import VSystemBar from './VSystemBar';
export { VSystemBar };
export default VSystemBar;
//# sourceMappingURL=index.js.map